import PropTypes from 'prop-types';
import EquivalencyState from '../../EquivalencyState';
import CheckIcon from '@mui/icons-material/Check';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CancelIcon from '@mui/icons-material/Cancel';
import { useTranslation } from 'react-i18next';
import './RequestStateChip.css';
import { Box, Typography } from '@mui/material';

interface RequestStateChipProps {
  state: string;
}

const RequestStateChip = ({ state }: RequestStateChipProps) => {
  const { t } = useTranslation();
  const getClassNameByState = (state: string) => {
    const className = 'RequestStateChip ';
    switch (state) {
      case EquivalencyState.rejected:
        return className + 'State-Rejected';
      case EquivalencyState.aproved:
        return className + 'State-Approved';
      case EquivalencyState.pending:
        return className + 'State-Pending';
      case EquivalencyState.review:
        return className + 'State-Review'
      default:
        return '';
    }
  };

  const getIcon = () => {
    if (state === EquivalencyState.aproved) {
      return <CheckIcon />;
    } else if (state === EquivalencyState.rejected) {
      return <CancelIcon />;
    } else if (state === EquivalencyState.pending) {
      return <AccessTimeIcon />;
    } else if (state === EquivalencyState.review) {
      return <AccessTimeIcon />;
    }
  };

  const getText = () => {
    if (state === EquivalencyState.aproved) {
      return t('finishedEquivalencyRequestTitle');
    } else if (state === EquivalencyState.rejected) {
      return t('rejectedEquivalencyRequestTitle');
    } else if (state === EquivalencyState.pending) {
      return t('pendingEquivalencyRequestTitle');
    } else if (state === EquivalencyState.review) {
      return t('inReviewEquivalencyRequestTitle');
    }
  };

  return (
    <Box className={getClassNameByState(state)}>
      <Typography className="RequestStateChip-Icon">{getIcon()} </Typography>
      <Typography data-testid="request-state">{getText()}</Typography>
    </Box>
  );
};

RequestStateChip.propTypes = {
  state: PropTypes.string
};

export default RequestStateChip;
